import type BABYLON from 'babylonjs';

export interface SkyboxOptions {
  pbr?: boolean;
  scale?: number;
  blur?: number;
  setGlobalEnvTexture?: boolean;
}

export function createSkybox(
  scene: BABYLON.Scene,
  { pbr, scale, blur, setGlobalEnvTexture }: SkyboxOptions = {}
): BABYLON.Nullable<BABYLON.Mesh> {
  return scene.createDefaultSkybox(
    scene.environmentTexture || undefined,
    pbr,
    scale,
    blur,
    setGlobalEnvTexture
  );
}

export function createOrUpdateSkybox(
  scene: BABYLON.Scene,
  options: SkyboxOptions | null = null
): BABYLON.Nullable<BABYLON.Mesh> {
  scene.meshes.find((mesh) => mesh.id === 'hdrSkyBox')?.dispose(false, true);
  return options ? createSkybox(scene, options) : null;
}
